export default __webpack_public_path__ + "static/media/bing-ads-logo.e58bb8f7.svg";